import { Button, Grid, Typography } from "@mui/material";
import { LIGHT_GREY } from "styles/oneOffColor";

import { TemplateMethod } from "features/Influencer/ContactList/schema";

interface Props {
  handleBack: () => void;
  handleNext: (method?: TemplateMethod) => void;
}

const styles = {
  aiCard: {
    p: 3,
    backgroundColor: "yellow.main",
    borderRadius: 4,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },
  nonAiCard: {
    p: 3,
    backgroundColor: LIGHT_GREY,
    borderRadius: 4,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },
};

const TemplateMethodForm = ({ handleBack, handleNext }: Props) => {
  return (
    <>
      <Typography variant="h3" gutterBottom sx={{ textAlign: "center" }}>
        How do you want to create your template?
      </Typography>

      <Grid container justifyContent="center">
        <Grid container gap={3} sx={{ my: 3, maxWidth: 800 }}>
          <Grid item xs={12} md={6} sx={styles.aiCard}>
            <Typography variant="h4">
              🚀 Use Bento AI to create a template
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Pick whether to create an outreach or a follow-up in the next
              screen.
            </Typography>

            <Button
              disableElevation
              sx={{ mt: 3 }}
              variant="contained"
              onClick={() => handleNext(TemplateMethod.use_bento_ai)}
            >
              Select
            </Button>
          </Grid>

          <Grid item xs md sx={styles.nonAiCard}>
            <Typography variant="h4">Write My Own</Typography>

            <Typography sx={{ mt: 2 }}>
              Use this option if you already have a template in mind or want to
              write it from scratch.
            </Typography>

            <Button
              onClick={() => handleNext(TemplateMethod.from_scratch)}
              disableElevation
              sx={{ mt: 3 }}
              variant="contained"
            >
              Select
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs="auto" container columnGap={1}>
        <Grid item xs="auto">
          <Button onClick={handleBack} color="secondary" disableElevation>
            Cancel
          </Button>
        </Grid>
        <Grid item xs></Grid>
      </Grid>
    </>
  );
};

export default TemplateMethodForm;
